(function() {
    'use strict'

    var pluginName = "menuOpener";
    var defaults = {
        /* some default options */
    };

    // Plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.options = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    // Plugin Methods
    Plugin.prototype = {
        init: function() {
            this.$element = $(this.element);
            this.$menuWrapper = $('.js-menu-wrapper');
            this.$menu = $('.js-menu');
            this.$links = $('a', this.$menu);
            this.$reelpreview = $('.js-reel-preview');
            this.bindEvents();
        },

        closeMenu: function() {
            this.$menuWrapper.css({
                height: 0
            });
            this.$menuWrapper.removeClass('is-open');
            this.$element.removeClass('is-active');
        },

        openMenu: function() {
            const menuHeight = this.$menu.outerHeight();

            this.$menuWrapper.css({
                height: menuHeight
            });
            this.$menuWrapper.addClass('is-open');
            this.$element.addClass('is-active');
        },

        toggleMenu: function(e) {
            e.preventDefault();

            if (this.$menuWrapper.hasClass('is-open')) {
                this.closeMenu();
            }
            else {
                this.openMenu();
            }
        },

        // EVENTS
        bindEvents: function() {
            this.$element.on('click', this.toggleMenu.bind(this));
            this.$links.on('click', this.closeMenu.bind(this));
        }
    };

    // Plugin wrapper
    $.fn[pluginName] = function(options) {
        return this.each(function() {
            if(!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
    }
}());
